<script lang="ts">
    import { setContext } from "svelte"
    export var value: any, name: string
    setContext(name, value)
</script>

<slot />
